import React from "react";
import { useNavigate } from "react-router";
import Button from "../../../components/button";
import DocumentPage from "../../../components/document-page";
import styles from '../styles.module.css';
import { HelpLink } from "../../../common/help";

function AgreementPage() {
  const navigation = useNavigate();

  const handleClickPrevPage = () => {
    navigation('/account');
  }

  return (
       <DocumentPage variant="scrollable" className="agreement-container">
                <h1>Согласие на обработку персональных данных</h1>
                <hr/>
        <div className="consent-header">
            <p>
                Настоящим, я подтверждаю своё согласие администрации сервиса «Openway» (далее — Оператор) на обработку моих персональных данных в соответствии с Федеральным законом РФ № 152-ФЗ «О персональных данных».
            </p>
        </div>

        <div className="section">
            <h2>1. Перечень персональных данных</h2>
            <p>Я даю согласие на обработку следующих персональных данных:</p>
            <ul>
                <li>Telegram ID и имя пользователя (username);</li>
                <li>контактные данные, предоставленные мной добровольно;</li>
                <li>дата регистрации в Сервисе;</li>
                <li>сведения о тарифе и подписке;</li>
                <li>технические идентификаторы, необходимые для работы сервиса;</li>
                <li>сведения о факте оплаты услуг (без данных платёжных карт).</li>
            </ul>
        </div>

        <div className="section">
            <h2>2. Цели обработки персональных данных</h2>
            <p>Персональные данные обрабатываются в следующих целях:</p>
            <ul>
                <li>предоставление доступа к сервису;</li>
                <li>управление подпиской и учёт услуг;</li>
                <li>обработка и подтверждение платежей;</li>
                <li>техническая поддержка пользователей;</li>
                <li>информирование о статусе услуг и подписки;</li>
                <li>выполнение требований действующего законодательства.</li>
            </ul>
        </div>

        <div className="section">
            <h2>3. Способы обработки персональных данных</h2>
            <p>Обработка персональных данных может осуществляться следующими способами:</p>
            <ul>
                <li>сбор;</li>
                <li>запись;</li>
                <li>систематизация;</li>
                <li>хранение;</li>
                <li>использование;</li>
            </ul>
            <p>Обработка может осуществляться как с использованием средств автоматизации, так и без их использования.</p>
        </div>

        <div className="section">
            <h2>4. Передача персональных данных</h2>
            <p>Я уведомлён(а), что персональные данные могут передаваться третьим лицам исключительно в следующих случаях:</p>
            <ul>
                <li>платёжным системам — в объёме, необходимом для обработки платежей;</li>
                <li>в случаях, предусмотренных законодательством Российской Федерации.</li>
            </ul>
            <p>Иная передача персональных данных третьим лицам не осуществляется.</p>
        </div>

        <div className="section">
            <h2>5. Срок действия согласия</h2>
            <p>Настоящее согласие действует с момента его предоставления и до момента отзыва согласия Пользователем либо прекращения использования Сервиса, если иное не предусмотрено законодательством.</p>
        </div>

        <div className="section">
            <h2>6. Отзыв согласия</h2>
            <p>Я уведомлён(а), что имею право в любой момент отозвать настоящее согласие путём обращения к администрации Сервиса. Отзыв согласия может повлечь невозможность дальнейшего предоставления услуг сервиса.</p>
        </div>

        <div className="section">
            <h2>7. Подтверждение согласия</h2>
            <p>Я подтверждаю, что:</p>
            <ul>
                <li>ознакомлен(а) с Политикой конфиденциальности сервиса «Openway»;</li>
                <li>понимаю цели и условия обработки персональных данных;</li>
                <li>даю согласие на обработку персональных данных добровольно.</li>
            </ul>
        </div>

        <div className="confirmation-note">
            <p><strong>Подтверждение:</strong> Нажимая кнопку "Согласен(а)" или используя Сервис, я подтверждаю своё согласие на обработку персональных данных в соответствии с настоящим документом.</p>
        </div>

        <div className="company-info">
            <h2>8. Контактная информация</h2>
            <p><strong>Telegram:</strong> <a href={HelpLink} target="_blank" rel="noreferrer">{HelpLink}</a></p>
        </div>

        <div className="footer-note">
            <p>© 2026 Openway. Все права защищены.</p>
        </div>
        <Button className={styles.btn} label="Назад" onClick={() => handleClickPrevPage()}></Button>
    </DocumentPage>
  );
}

export default AgreementPage;